export type EditorField = {
  label: string;
  kind: "text" | "date";
};

export const profileFields = [
  { label: "Imię", kind: "text" },
  { label: "Nazwisko", kind: "text" },
  { label: "Adres 1", kind: "text" },
  { label: "Adres 2", kind: "text" },
  { label: "Data", kind: "date" },
] as const;
